import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { forwardRef } from "react";
import classnames from "classnames";
import Button from "@mui/material/Button";
import { Box } from "../Box/index.js";
import { CircularProgress } from "../CircularProgress/index.js";
import Button_styles from "./Button.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function Button_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else Button_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const muiVariants = {
    primary: 'contained',
    quaternary: 'contained',
    quaternaryAccent: 'contained',
    quaternaryDark: 'contained',
    warning: 'contained',
    secondary: 'outlined',
    tertiaryLight: 'text',
    tertiaryDark: 'text',
    tertiaryBlue: 'text'
};
const aqaClasses = {
    primary: 'aqa_button_primary',
    secondary: 'aqa_button_secondary',
    quaternary: 'aqa_button_quaternary',
    quaternaryAccent: 'aqa_button_quaternary',
    warning: 'aqa_button_warning',
    tertiaryDark: 'aqa_button_tertiaryDark',
    tertiaryBlue: 'aqa_button_tertiaryBlue',
    tertiaryLight: '',
    quaternaryDark: ''
};
const Button_Button = /*#__PURE__*/ forwardRef((t0, ref)=>{
    const $ = c(50);
    let children;
    let className;
    let icon;
    let onClick;
    let rest;
    let startIcon;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let testId;
    if ($[0] !== t0) {
        ({ className, children, type: t1, disabled: t2, disableRipple: t3, icon, startIcon, fullWidth: t4, loading: t5, size: t6, variant: t7, onClick, testId } = t0), rest = _object_without_properties(t0, [
            "className",
            "children",
            "type",
            "disabled",
            "disableRipple",
            "icon",
            "startIcon",
            "fullWidth",
            "loading",
            "size",
            "variant",
            "onClick",
            "testId"
        ]);
        $[0] = t0;
        $[1] = children;
        $[2] = className;
        $[3] = icon;
        $[4] = onClick;
        $[5] = rest;
        $[6] = startIcon;
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
        $[14] = testId;
    } else {
        children = $[1];
        className = $[2];
        icon = $[3];
        onClick = $[4];
        rest = $[5];
        startIcon = $[6];
        t1 = $[7];
        t2 = $[8];
        t3 = $[9];
        t4 = $[10];
        t5 = $[11];
        t6 = $[12];
        t7 = $[13];
        testId = $[14];
    }
    const type = void 0 === t1 ? "button" : t1;
    const disabled = void 0 === t2 ? false : t2;
    const disableRipple = void 0 === t3 ? false : t3;
    const fullWidth = void 0 === t4 ? false : t4;
    const loading = void 0 === t5 ? false : t5;
    const size = void 0 === t6 ? "medium" : t6;
    const variant = void 0 === t7 ? "primary" : t7;
    const { classes } = Button_styles();
    const t8 = classes[variant];
    const t9 = !!icon && !children && `${classes.buttonIconOnly}${"primary" === variant ? ` ${classes.buttonPrimaryIconOnly}` : ""}`;
    const t10 = loading && `${classes.buttonLoading} buttonLoading`;
    const t11 = aqaClasses[variant];
    const t12 = "extraSmall" === size && classes.extraSmall;
    let t13;
    if ($[15] !== className || $[16] !== classes.button || $[17] !== t10 || $[18] !== t11 || $[19] !== t12 || $[20] !== t8 || $[21] !== t9) {
        t13 = classnames(classes.button, t8, t9, t10, className, "aqa_button", t11, t12);
        $[15] = className;
        $[16] = classes.button;
        $[17] = t10;
        $[18] = t11;
        $[19] = t12;
        $[20] = t8;
        $[21] = t9;
        $[22] = t13;
    } else t13 = $[22];
    const buttonStyles = t13;
    const muiVariant = muiVariants[variant] || variant;
    let t14;
    if ($[23] !== loading || $[24] !== onClick) {
        t14 = (e)=>{
            if (loading) return;
            null == onClick || onClick(e);
        };
        $[23] = loading;
        $[24] = onClick;
        $[25] = t14;
    } else t14 = $[25];
    const handleClick = t14;
    const t15 = "extraSmall" === size ? "small" : size;
    const t16 = loading ? "button" : type;
    const t17 = loading ? "hidden" : "visible";
    const t18 = disabled ? "none" : "auto";
    let t19;
    if ($[26] !== children || $[27] !== t17 || $[28] !== t18) {
        t19 = /*#__PURE__*/ jsx(Box, {
            visibility: t17,
            pointerEvents: t18,
            children: children
        });
        $[26] = children;
        $[27] = t17;
        $[28] = t18;
        $[29] = t19;
    } else t19 = $[29];
    let t20;
    if ($[30] !== classes.loading || $[31] !== loading || $[32] !== size) {
        t20 = loading && /*#__PURE__*/ jsx(CircularProgress, {
            size: "extraSmall" === size ? 12.6 : 18.8,
            className: classes.loading,
            color: "inherit"
        });
        $[30] = classes.loading;
        $[31] = loading;
        $[32] = size;
        $[33] = t20;
    } else t20 = $[33];
    let t21;
    if ($[34] !== buttonStyles || $[35] !== disableRipple || $[36] !== disabled || $[37] !== fullWidth || $[38] !== handleClick || $[39] !== icon || $[40] !== muiVariant || $[41] !== ref || $[42] !== rest || $[43] !== startIcon || $[44] !== t15 || $[45] !== t16 || $[46] !== t19 || $[47] !== t20 || $[48] !== testId) {
        t21 = /*#__PURE__*/ jsxs(Button, _object_spread_props(_object_spread({
            "data-testid": testId,
            color: "primary",
            variant: muiVariant,
            className: buttonStyles,
            disabled: disabled,
            disableRipple: disableRipple,
            fullWidth: fullWidth,
            startIcon: startIcon,
            endIcon: icon,
            size: t15,
            type: t16,
            onClick: handleClick,
            ref: ref
        }, rest), {
            children: [
                t19,
                t20
            ]
        }));
        $[34] = buttonStyles;
        $[35] = disableRipple;
        $[36] = disabled;
        $[37] = fullWidth;
        $[38] = handleClick;
        $[39] = icon;
        $[40] = muiVariant;
        $[41] = ref;
        $[42] = rest;
        $[43] = startIcon;
        $[44] = t15;
        $[45] = t16;
        $[46] = t19;
        $[47] = t20;
        $[48] = testId;
        $[49] = t21;
    } else t21 = $[49];
    return t21;
});
export { Button_Button as Button };
